// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","274":"component---src-pages-cookie-policy-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"223":"8353ca85c7a023405dcb","274":"e80c11496724887548d7","293":"778a2764d142914fd0e4","522":"981f36ad2f25c419b978"}[chunkId] + ".js";
};